import React from "react";

const WhyChooseUs = () => {
  // Feature list data structure
  const features = [
    {
      title: "Government Standards Compliance",
      desc: "We strictly adhere to government security protocols and data protection regulations in all our projects.",
    },
    {
      title: "24/7 Dedicated Support",
      desc: "Our technical team is always available to ensure your systems run smoothly without downtime.",
    },
    {
      title: "Customized Scalable Solutions",
      desc: "We build software that grows with your organization, avoiding the limitations of off-the-shelf products.",
    },
    {
      title: "On-Time Delivery",
      desc: "We value your time and adhere to strict project timelines to ensure your operations start on schedule.",
    },
  ];

  return (
    // Section Container: White background, good vertical padding
    <section className="py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid Layout: 1 column on mobile, 2 columns on desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* --- Left Column: Content --- */}
          <div className="order-2 lg:order-1">
            {/* Section Header */}
            <h2 className="text-blue-600 font-semibold tracking-wide uppercase text-sm mb-3">
              Why Choose Us
            </h2>
            <h3 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-6 leading-tight">
              We Bridge the Gap Between <br />
              <span className="text-slate-700">Technology & Governance</span>
            </h3>
            <p className="text-lg text-slate-600 mb-10 leading-relaxed">
              Choosing the right technology partner is critical for government
              agencies. We combine deep technical expertise with an
              understanding of public sector workflows to deliver results that
              matter.
            </p>

            {/* Features List */}
            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex">
                  {/* Icon Container */}
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-50 text-blue-600 border border-blue-100">
                      {/* Check Icon */}
                      <svg
                        className="h-6 w-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Text Content */}
                  <div className="mr-4 ml-4">
                    <h4 className="text-lg font-bold text-slate-900 mb-1">
                      {feature.title}
                    </h4>
                    <p className="text-base text-slate-600">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Additional CTA Button inside the section */}
            {/* <div className="mt-10">
              <a
                href="/about"
                className="text-blue-600 font-bold hover:text-blue-800 flex items-center transition-colors"
              >
                Learn More About Our Process
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </a>
            </div> */}
          </div>

          {/* --- Right Column: Image --- */}
          <div className="order-1 lg:order-2 relative">
            {/* Decorative Shapes behind image */}
            <div className="absolute -top-4 -right-4 w-24 h-24 border-t-4 border-r-4 border-blue-600 rounded-tr-3xl opacity-50"></div>
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-4 border-l-4 border-blue-300 rounded-bl-3xl opacity-50"></div>

            {/* Main Image Container */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                alt="Team working in a modern office environment"
                className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
              />
            </div>

            {/* Floating Stat Card (Optional visual flair) */}
            <div className="absolute bottom-8 left-8 bg-white/95 backdrop-blur-sm p-5 rounded-xl shadow-xl border border-slate-100 hidden sm:block max-w-[200px]">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-green-100 p-1.5 rounded-full">
                  <svg
                    className="w-4 h-4 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
                <span className="text-sm font-bold text-slate-800">
                  98% Uptime
                </span>
              </div>
              <p className="text-xs text-slate-500">
                Guaranteed system availability.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
